import { render, staticRenderFns } from "./StoryPage1.vue?vue&type=template&id=7a539bc4&"
import script from "./StoryPage1.vue?vue&type=script&lang=js&"
export * from "./StoryPage1.vue?vue&type=script&lang=js&"
import style0 from "./StoryPage1.vue?vue&type=style&index=0&id=7a539bc4&prod&scopped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports